import React from 'react';
import { workshops } from '../../portfolio';
import { ExternalLink } from 'lucide-react';

const Workshops = () => {
  return (
    <section className="section">
      <div className="section-header">
        <h1 className="section-title">Workshops & Speaking</h1>
        <p className="section-subtitle">Sessions I've conducted and talks I've given.</p>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        {workshops.map((w, idx) => (
          <div key={idx} style={{ padding: '32px', background: 'var(--surface)', borderRadius: 'var(--radius)', border: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
            <div style={{ paddingRight: '24px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '16px' }}>
                <span style={{ fontSize: '11px', fontWeight: 600, padding: '4px 8px', background: 'var(--border)', color: 'var(--text-2)', borderRadius: '6px', textTransform: 'uppercase', letterSpacing: '0.05em' }}>{w.type || 'Workshop'}</span>
                <span style={{ fontSize: '13px', color: 'var(--text-3)' }}>{w.date}</span>
              </div>
              <h4 style={{ fontSize: '18px', fontWeight: 600, color: 'var(--text-1)', marginBottom: '12px' }}>{w.title}</h4>
              <div style={{ fontSize: '14px', color: 'var(--text-2)', marginBottom: '16px', fontWeight: 500 }}>{w.organization && `${w.organization} • `}{w.duration} {w.participants && `• ${w.participants}`}</div>
              <p style={{ fontSize: '15px', color: 'var(--text-2)', lineHeight: 1.6 }}>{w.description}</p>
            </div>
            {w.link && (
              <a href={w.link} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--text-2)', padding: '12px', background: 'var(--bg)', borderRadius: '8px', border: '1px solid var(--border)', flexShrink: 0 }}>
                <ExternalLink size={18} />
              </a>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default Workshops;
